import { HtmlHTMLAttributes, ReactNode } from 'react'
import Ellipsis from './Ellipsis'
import './ResizeBar.css'

interface ResizeBarProps extends HtmlHTMLAttributes<HTMLDivElement> {
  direction: 'horizontal' | 'vertical'
  children?: ReactNode
}

function ResizeBar({
  direction,
  children = undefined,
  className = '',
  ...rest
}: ResizeBarProps) {
  return (
    <div
      role="presentation"
      className={`ResizeBar ResizeBar--${direction} ${className}`}
      {...rest}
    >
      {children || <Ellipsis className={`ResizeBar__ellipsis-${direction}`} />}
    </div>
  )
}

export default ResizeBar
